import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import { twMerge } from '@beerntea/pitcher-ui';

interface VideoPlayerProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  upload_id: string | null;
  play: boolean;
  className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ upload_id, play = false, className = '' }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hlsRef = useRef<Hls | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_isPlaying, setIsPlaying] = useState(play);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !upload_id) return;
    const videoSrc = `https://cloudflarestream.com/${upload_id}/manifest/video.m3u8?&muted=false&`;

    if (Hls.isSupported()) {
      hlsRef.current = new Hls();
      hlsRef.current.loadSource(videoSrc);
      hlsRef.current.attachMedia(video);
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoSrc;
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
      if (video) {
        video.pause();
        // Remove all child nodes (if any were added)
        while (video.firstChild) video.removeChild(video.firstChild);
      }
    };
  }, [upload_id]);

  useEffect(() => {
    const video = videoRef.current;
    const t = setInterval(() => {
      if (!video) return;
      setIsPlaying(!video.paused);
    }, 200);
    return () => {
      clearInterval(t);
    };
  }, []);

  const toggleVideo = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) video.play();
    else video.pause();
    setIsPlaying(!video.paused);
  };

  if (!upload_id) return <div>No video available</div>;

  return (
    <video
      className={twMerge('tw-w-full tw-h-full tw-object-cover', 'tw-mix-blend-screen', className)}
      onClick={() => {
        toggleVideo();
      }}
      ref={videoRef}
      controls={false}
      preload="auto"
      playsInline
      muted
      loop
      autoPlay={true}
    />
  );
};

export default VideoPlayer;
